// import React from "react";
// import { Route, Redirect } from "react-router-dom";
// // import Cookies from 'js-cookie';
// const PrivateRoute = ({ component: Component, ...rest }) => {
//     const accessToken = localStorage.getItem("accessToken");
//     const refreshToken = localStorage.getItem("refreshToken");
//     // const refreshToken = Cookies.get('refreshToken');

//     return (
//         <Route
//             {...rest}
//             render={(props) =>
//                 accessToken && refreshToken ? (
//                     <Component {...props} />
//                 ) : (
//                     <Redirect to="/login" />
//                 )
//             }
//         />
//     );
// };

// export default PrivateRoute;

import React from "react";
import { Route, Redirect } from "react-router-dom";
// import Cookies from 'js-cookie';
const PrivateRoute = ({ component: Component, children, ...rest }) => {
    const accessToken = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");
    // const refreshToken = Cookies.get('refreshToken');

    return (
        <Route
            {...rest}
            render={(props) =>
                accessToken && refreshToken ? (
                    Component ? <Component {...props} /> : children
                ) : (
                    <Redirect to="/login" />
                )
            }
        />
    );
};

export default PrivateRoute;

